var app;
var lazyload;

app = {

	dependencies : {

		list : [
			// {
			// 	name : 'proposition',
			// 	type : 'json',
			// 	path : dir + 'data/proposition/list.json'
			// }
		],

		load : function() {

			var dependencies, requests, pending, script, json;

			dependecies = this.list;
			pending = dependecies.length;

			json = function( path, callback ) {

				var request;

				request = new XMLHttpRequest();
				request.overrideMimeType( 'application/json' );
				request.open( 'GET', path, true );

				request.onload = function () {
					if ( request.readyState == 4 && request.status == 200 )
						callback( request.responseText )
				}

				request.send();
			}

			if ( dependecies.length > 0 ) {

				each( dependecies, function( dependency ) {

					if ( dependency.type == 'json' ) {

						json( dependency.path, function( response ) {
							app.data[ dependency.name ] = JSON.parse( response );
							--pending;
							if ( pending <= 0 ) app.dependencies.callback()
						});

					}

				})

			} else {

				app.dependencies.callback()

			}

		},

		callback : function() {
			// dependencies loaded
			app.components.initialize();
			app.interaction.initialize();
			app.embed.initialize();
		}

	},

	data : {},

	url : {

		parameters : {

			encode : function( object ) {
				var string = [];
				for ( var p in object ) {
    			if ( object.hasOwnProperty( p ) ) {
    				var property = encodeURIComponent( p );
    				var value = encodeURIComponent( object[ p ] )
    				string.push( property + '=' + value );
    			}
				}
				return string.join( '&' );
			},

			decode : function( string ) {
				var object = {};
				string.split( '&' ).forEach( function( part ) {
          var arr = part.split( '=' );
          var key = arr[ 0 ];
          var val = arr[ 1 ];
          object[ key ] = decodeURIComponent( val );
        });
				return object;
			},

			get : function() {
				var string = window.location.search.slice( 1 );
        return this.decode( string );
			},

			update : function( object, action ) {
				var path = window.location.origin + window.location.pathname;
				var hash = window.location.hash;
				var parameters = this.get();
				for ( var p in object ) {
					if ( object[ p ] === 'all' ) {
						delete parameters[ p ];
					} else {
						parameters[ p ] = object[ p ];
					}
				}
				parameters = '?' + this.encode( parameters );

				if ( action === 'refresh' ) {
					window.location = path + parameters + hash;
				} else {
					history.replaceState( null, null, path + parameters + hash );
				}

			}

		}

	},

	components : {

		graphics : {

			votings : {

				recount : function() {

					each( 'voting', function() {

						var graphic = the( 'graphic', this );
						var total = 0;
						var others = 0;

						each( '.voters.list section', function() {

							var position      = this.dataset.position;
							var voters        = this.dataset.voters;
							var graphic       = the( '.voting.result .graphic' );

							each( 'a', function() {

								if ( this.dataset.position === position ) {

									this.dataset.voters = voters;
									this.querySelector( '.tooltip output' ).innerHTML = voters;
									total += parseInt( voters );

									if ( this.dataset.position !== '1' && this.dataset.position !== '2' && this.dataset.position !== '11' )
									{
										others += parseInt( voters );
									}

								}

							}, graphic )

						} )

						graphic.dataset.total = total;

						graphic.querySelector( '.others' ).dataset.voters = others;


					} )

					this.update();

				},

				update : function() {

					each( 'voting', function() {

						var graphic = the( 'graphic', this )
						var caption = the( 'figcaption', this )
						var total   = graphic.dataset.total;

						each( 'a', function() {

							var position = this.dataset.position;
							var voters = this.dataset.voters;
							var percentage = voters / total * 100 + '%';

							var order = getOrder( voters, this.dataset.position );
							setOrder( order, this );

							this.style.width = percentage;

							each( 'div', function() {

								if ( this.dataset.position === position ) {

									setOrder( order, this );
									this.querySelector( 'output' ).innerText = this.dataset.voters = voters

								}

							}, caption )

						}, graphic )

					} )

				},

				modify : function() {

					if ( the( '[data-limit="symbolic"]' ) ) {

						if ( the( '[data-page]' ).dataset.page === 'voting' ) {

							the( '.legend[data-content="colors"]' ).style.display = 'none'

						}

					}

					each( '[data-limit="symbolic"]', function() {
						var parent = this.closest( '.scoreboard' ) || this.closest( '.item' );
						var h2     = the( 'h2', parent );
						h2.innerHTML = 'Votação simbólica';
						h2.classList.remove( 'screen-reader' );
					} )

				},

				initialize : function() {

					this.modify();
					this.update();

				}
			}
		},

		cards : {

			voter : {

				initialize : function() {

					var changes = the( 'changes' );

					if ( changes ) {

						var voters = the( '.voters.list' );

						each( 'li[data-voter]', function() {

							var id = this.dataset.voter;
							var voter = the( 'li[data-voter="' + id + '"]', voters );
							var button = document.createElement( 'a' );
							button.classList.add( 'changed' );
							button.setAttribute( 'href', 'javascript:void(0)' );
							button.innerHTML = 'Mudou';

							button.addEventListener( 'click', function() {

								target = this.closest( 'li' ).dataset.voter;

								each( 'li[data-voter]', function() {

									var item = this;

									if ( item.dataset.voter === target ) {
										scrollToElement( item );
										item.classList.add( 'highlight' );
										setTimeout( function(){
											item.classList.remove( 'highlight' );
										}, 6000 );
									}
									else {
										item.classList.remove( 'highlight' );
									}

								}, changes );

							});

							var figcaption = document.createElement( 'figcaption' );
							figcaption.appendChild( button );

							the( 'figure', voter ).appendChild( figcaption );

						}, changes );

					}
				}
			},

			initialize : function() {
				this.voter.initialize();
			}

		},

		initialize : function() {
			this.graphics.votings.initialize();
			this.cards.initialize();
		}

	},

	interaction : {

		list : {

			isFiltered : function() {

			  var boolean = false

			  each( 'form select', function() {

			    if ( this.value !== 'all' ) boolean = true

			  } )

			  if ( the( 'search' ) && the( 'search' ).value ) boolean = true

			  return boolean

			},

			recount : function() {

				each( '.voters.list section', function() {

					var visible = this.querySelectorAll( '[data-visible="true"]' );
					var count   = visible.length;
					var position = this.dataset.position;

					this.querySelector( 'header output' ).innerText = this.dataset.voters = count;

					var order = getOrder( count, position );
					setOrder( order, this );

				} )

				app.components.graphics.votings.recount();

				if ( this.isFiltered() ) {
					the( '[data-page]' ).dataset.filtered = 'true'
					app.interaction.viewAll.destroy();
				} else {
					the( '[data-page]' ).dataset.filtered = 'false'
				}



			},

			animate : function() {

				var list = the( 'list' )

				list.dataset.animation = 'false'

				setTimeout( function() {

					list.dataset.filtering = 'false'
					list.dataset.animation = 'true'

				}, 100 )

			},

			uncollapse : function() {

				each( '.voters.list section', function() {

					this.classList.remove( 'collapsed' );

				} )

			}

		},

		modal : {

			hide : function() {

				app.interaction.modal.video.source.set( undefined );
				document.documentElement.dataset.modal = 'false';

			},

			show : function( target ) {

				var type  = target.dataset.type;

				if ( type === 'video' ) {

					var id = target.dataset.content;
					app.interaction.modal.video.source.set( id );

				}

				document.documentElement.dataset.modal = type;

			},

			toggle : function( event ) {

				var type  = this.dataset.type;
				var modal = document.documentElement.dataset.modal;

				if ( modal === 'false' ) {

					app.interaction.modal.show( this );

				} else {

					app.interaction.modal.hide();

				}

				event.stopPropagation();

			},

			video : {

				source : {

					iframe : the( '.modal[data-type="video"] iframe' ),

					get : function() {

						return this.iframe.src;

					},

					set : function( id ) {

						if ( id === undefined ) {

							this.iframe.src = '';

						} else {

							this.iframe.style.display = 'none';

							var options = {
								'autoplay'       : '1',
								'autohide'       : '1',
								'color'          : 'white',
								'fs'             : '1',
								'iv_load_policy' : '3',
								'modestbranding' : '1',
								'rel'            : '0',
								'showinfo'       : '0',
								'showsearch'     : '0'
							};

							var url = 'https://www.youtube.com/embed/' + id + '?' + httpBuildQuery( options );
							var old = this.get();

							if ( url !== old ) {

								this.iframe.src = url;

							} else {

								this.iframe.style.display = 'block';

							}

						}

					}

				},

				initialize : function() {

					this.source.iframe.addEventListener( 'load', function() {

						this.style.display = 'block';

					} )

				}

			},

			initialize : function() {

				var toggle = this.toggle;
				var hide   = this.hide;

				each( '[data-trigger="modal"]', function() {
					this.addEventListener( 'click', toggle )
				} )

				each( 'modal', function() {
					this.addEventListener( 'click', function( event ) {
						event.stopPropagation();
					} )
				} )

				each( 'close', function() {
					this.addEventListener( 'click', hide )
				} )

				the( 'overlay' ).addEventListener( 'click', toggle )

				this.video.initialize();

			}

		},

		share : {

			clipboard : {

				initialize : function() {

					var button = the( 'clipboard-button' );

					label = function( text ) {
						text = text || 'Copiar';
						button.querySelector( 'span span' ).innerHTML = text
					}

					if ( Clipboard.isSupported() ) {

						var clipboard = new Clipboard( button )

						clipboard.on( 'success', function() {
							label( 'Copiado!' )
							setTimeout( label, 5000 );
						});

						clipboard.on( 'error', function() {
							label( 'Aperte Ctrl+C' )
						});

					} else {

						the( 'clipboard' ).style.display = 'none';

					}

				}

			},

			initialize : function() {

				this.clipboard.initialize();

			}

		},

		hover : {

			initialize : function() {

				var list = the( 'list' );

				each( 'li', function() {

					this.addEventListener( 'mouseenter', function() {

						var hovered = this;

						this.classList.remove( 'unhover' )
						this.classList.add( 'hover' )

						each( 'li', function() {

							if ( this !== hovered ) this.classList.add( 'unhover' )

						}, list );

					})

					this.addEventListener( 'mouseleave', function() {

						each( 'li', function() {

							this.classList.remove( 'unhover', 'hover' );

						}, list );

					})

				}, list );

			}

		},

		card : {

			initialize : function() {

				each( '.list li.read-more article section', function() {

					this.addEventListener( 'click', function() {
						this.previousElementSibling.click()
					})

					each( 'a', function() {
						this.addEventListener( 'click', function( event ) {
							event.stopPropagation()
						})
					}, this )

				} )

			}

		},

		collapse : {

			initialize : function() {

				each( '.voters.list section header', function() {

					this.addEventListener( 'click', function( event ) {

						this.closest( 'section' ).classList.toggle( 'collapsed' );

						setTimeout( function(){
							lazyload.update()
						}, 600 );

					} )

				} )

			}

		},

		search : {

			initialize : function() {

				document.addEventListener( 'input', function ( event ) {

					var search = the( 'search' );

					if ( event.target === search ) {

						delay( function() {

							console.log( 'working' );

							var list = the( 'list' );

							list.dataset.filtering = 'true';

							each( 'form select', function() {

								clear( this )

							} )

							each( 'li', function() {

								this.dataset.visible = 'true'

							}, list )

							var input = normalizeString( search.value );

							each( '.voters li', function() {

								if ( this.dataset.visible === 'true' ) {

									var name = normalizeString( the( 'p-name', this ).innerHTML );

									if ( name.includes( input ) ) {

										this.dataset.visible = 'true'

									} else {

										this.dataset.visible = 'false'

									}

								}

							}, list )

							app.interaction.list.uncollapse();
							app.interaction.list.recount();
							app.interaction.list.animate();
							noResultsChecker();
							lazyload.update();

						}, 250 );

					}

				}, false );

			}

		},

		select : {

			query : '',

			update : function() {

				var list = the( 'list' );

				list.dataset.filtering = 'true';

				clear( the( 'search' ) )

				each( 'li', function() {

					this.dataset.visible = 'true'

				}, list )

				each( 'form select', function() {

					var option   = this.value;
					var property = this.id.split( '-' )[ 1 ];
					var target   = {};

					var parameters = {};
					parameters[ property ] = option;
					app.url.parameters.update( parameters );

					if ( property === 'categories' && option !== 'all' ) {

						var object = JSON.parse( option );

						for ( var name in object ) {
							target[ name ] = object[ name ];
						}

					}

					each( 'li', function() {

						if ( this.dataset.visible === 'true' ) {

							if ( option === 'all' ) {

								this.dataset.visible = 'true'

							} else {

								if ( property === 'categories' ) {

									var value = JSON.parse( this.querySelector( '.item' ).dataset[ property ] );

									for ( var name in target ) {

										if ( value[ name ] === target[ name ] ) {

											this.dataset.visible = 'true'

										} else {

											this.dataset.visible = 'false'

										}

									}

								} else {

									var value = normalizeString( this.querySelector( '.item' ).dataset[ property ] );

									if ( value === normalizeString( option ) ) {

										this.dataset.visible = 'true'

									} else {

										this.dataset.visible = 'false'

									}

								}

							}

						}

					}, list )

					app.interaction.list.recount();
					app.interaction.list.animate();
					app.url.parameters.update();
					noResultsChecker();
					lazyload.update();

				} )

			},

			prefilter : function() {

				var prefilters = [];
				var filters = [ 'party', 'state', 'categories' ];

				each( filters, function( filter ) {
					prefilters.push( findGetParameter( filter ) );
				} );

				each( prefilters, function( prefilter, i ) {
					if ( prefilter !== null )
						document.getElementById( 'select-' + filters[ i ] ).value = prefilter;
				} );

				var prefiltersExist = prefilters.some(function (el) { return el !== null } );

				if ( prefiltersExist )
					app.interaction.select.update();

			},

			initialize : function() {

				document.addEventListener( 'change', function( event ) {

					if ( the( 'form' ).contains( event.target ) )
						app.interaction.select.update();

				} )

				this.prefilter();

			}

		},

		viewAll : {

			destroy : function() {

				each( '.voters.list section[data-visibility]', function() {

					this.dataset.visibility = 'total';

				} )

			},

			initialize : function() {

				each( '.voters.list section .view-all button', function() {

					this.addEventListener( 'click', function( event ) {

						var section = this.parentElement.parentElement;
						section.dataset.visibility = 'total';
						lazyload.update();

					} )

				} )

			}

		},

		initialize : function() {

			this.modal.initialize()
			this.share.initialize()
			this.hover.initialize()
			this.card.initialize()
			this.collapse.initialize()
			this.search.initialize()
			this.select.initialize()
			this.viewAll.initialize()

		}

	},

	events : {

		load : function() {

			lazyload = new LazyLoad( { threshold: 1000	} );

			browser();
			scale();

		},

		resize : function() {

			window.addEventListener( 'resize', function() {

				scale();

			});

		},

		timely : function() {

			setInterval( function() {
				lazyload.update();
			}, 2000 );

		},

		initialize : function() {

			this.load();
			this.resize();
			this.timely();

		}

	},

	embed : {

		scale : function() {
			var w = document.documentElement.offsetWidth || document.documentElement.clientWidth;
			var ratio = ( w / 350 ) > 1 ? 1 : w / 350;
			var transform = 'scale( ' + ratio + ' )' ;
			var element = document.documentElement;
			element.style.webkitTransform = transform;
			element.style.MozTransform = transform;
			element.style.msTransform = transform;
			element.style.OTransform = transform;
			element.style.transform = transform;
	},

		initialize : function() {

			if ( the( 'select-embed-size' ) ) {

				the( 'select-embed-size' ).addEventListener( 'change', function() {

					app.url.parameters.update( { size: this.value }, 'refresh' );

				} );

			}

			if ( the( 'input-embed-photo' ) ) {

				the( 'input-embed-photo' ).addEventListener( 'change', function() {

					app.url.parameters.update( { photo: this.checked }, 'refresh' );

				} );

			}

			if ( document.documentElement.dataset.embed === 'true' ) {

				if ( the( '.screenshot' ).dataset.iframe === 'true' ) {

					the( '.screenshot' ).addEventListener( 'click', function() {
						window.top.location = window.location.href.replace( '/embed/', '/').replace( '&iframe', '');
					} )

					window.addEventListener( 'resize', function() {

						app.embed.scale()

					} );

					app.embed.scale()

				}

				if ( the( '.screenshot' ).dataset.photo === 'true' ) {

					var overlay = document.createElement( 'div' );
					overlay.classList.add( 'figure-overlay' );
					the( '.intro figure .placeholder' ).appendChild( overlay );

				}

				if ( the( '.status' ).dataset.status !== 'pending' ) {

					the( '.status' ).querySelector( 'span' ).style.display = 'none';

				}

				if ( the( '[data-page]' ).dataset.size === '750x423' ) {

					// var photo = the( '.intro figure img' ).src;
					// the( '[data-page]' ).style.backgroundImage = 'url(' + photo + ')';

					// var overlay = document.createElement( 'div' );
					// overlay.classList.add( 'photo-overlay' );
					// the( '[data-page]' ).insertBefore( overlay, the( '[data-page]' ).firstChild );

				}


				each( '[data-page]', function() {
					var output = this.querySelector( '.threshold p output' ).innerHTML;
					this.querySelector( '.threshold p' ).innerHTML = '<output>' + output + '</output>' + 'votos&nbsp;necessários';
				} );

				if ( the( 'screenshot' ).dataset.compare === 'true' ) {

					each( '.p-category', function() {
						if ( this.innerHTML === 'Câmara (CCJ)' )
							this.innerHTML = 'Comissão&nbsp;de&nbsp;Constituição&nbsp;e&nbsp;Justiça';
						if ( this.innerHTML === 'Câmara dos Deputados' )
							this.innerHTML = 'Plenário&nbsp;da&nbsp;Câmara';
					} );

					if (  the( '[data-page]:first-child .status' ).dataset.status === the( '[data-page]:last-child .status' ).dataset.status ) {
						the( '[data-page]:last-child .status' ).style.visibility = 'hidden';
					}

					var source = the( '[data-page]:last-child .intro figure img' ).src;
					var photo = document.createElement( 'div' );
					photo.classList.add( 'photo' );
					photo.style.backgroundImage = 'url(' + source + ')';
					the( 'screenshot' ).insertBefore( photo, the( 'screenshot' ).firstChild )

				}

				// var output = the( '.threshold p output' ).innerHTML;
				// the( '.threshold p' ).innerHTML = '<output>' + output + '</output>' + 'votos&nbsp;necessários';

			}

		}

	},

	initialize : function() {

		app.events.initialize();
		this.dependencies.load();

	},

	update : function() {

	}

};

app.initialize();
